// components
import {
  styled,
  Box,
  BoxProps,
  Stack,
  StackProps,
  TableContainer,
  TableContainerProps,
  TableCell,
  TableCellProps,
  TableRow,
  TableRowProps,
  Typography,
  TypographyProps
} from '@mui/material';

export const StyledOpenRequestsStack = styled(Stack)<StackProps>(
  ({ theme }) => ({
    paddingBottom: theme.spacing(4),
    marginTop: theme.spacing(-2),
    flexDirection: 'row',
    gap: theme.spacing(2),
    justifyContent: 'space-between'
  })
);

export const StyledOpenRequestsTableBox = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  maxHeight: 'calc(100vh - 200px)',
  overflowY: 'auto',
  overflowX: 'hidden'
}));

export const StyledOpenRequestsTableContainer = styled(
  TableContainer
)<TableContainerProps>(() => ({
  overflow: 'visible',
  maxHeight: 'none'
}));

export const StyledOpenRequestsTableCell = styled(TableCell)<TableCellProps>(
  ({ theme }) => ({
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: theme.palette.background.paper
  })
);

export const StyledDateTypography = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    lineHeight: 'normal',
    paddingTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  })
);

export const StyledBreakdownTableRow = styled(TableRow)<TableRowProps>(
  ({ theme }) => ({
    // maatvoering staat bij de andere kleuren/maten in QualityMonitorStyles
    // (.is-breakdown), zodat naam en cijfers van een subregel niet uiteenlopen
    color: theme.palette.text.secondary
  })
);

export const StyledBreakdownNameCell = styled(TableCell)<TableCellProps>(
  ({ theme }) => ({
    color: theme.palette.text.secondary
  })
);

// ponytail: de flexrij zit in de cel, niet op de cel zelf — display:flex op een
// TableCell haalt hem uit de tabel-layout (kolombreedte en rijhoogte lopen dan
// scheef t.o.v. de twee tabellen ernaast)
export const StyledNameCellContent = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  // laat de naam krimpen i.p.v. de flexrij oprekken, zodat ellipsis werkt
  minWidth: 0
}));

// ponytail: hidden chevron keeps the breakdown icon on the same x as the plan unit name
export const StyledExpandToggleSpacer = styled(Box)<BoxProps>(() => ({
  visibility: 'hidden'
}));
